import Banner from "@/components/ui/banner/Banner";
import Breadcrumbs from "@/components/ui/Breadcrumbs";
import SEOMeta from "@/components/ui/meta/SEOMeta";

type Breadcrumb = { label: string; path?: string };

interface InfoPageLayoutProps {
  pageTitle: string;
  bannerImage: { default: string; desktop: string };
  breadcrumbs?: Breadcrumb[];
  ogImage?: string;
  children: React.ReactNode;
  bannerImagAlign?: "left" | "center" | "right";
}

const InfoPageLayout = ({
  pageTitle,
  bannerImage,
  breadcrumbs,
  ogImage,
  children,
  bannerImagAlign,
}: InfoPageLayoutProps) => {
  return (
    <main className="brand-main pb-20">
      <Banner
        banner={{
          image: {
            default: bannerImage.default,
            desktop: bannerImage.desktop,
          },
          title: pageTitle,
          description: breadcrumbs ? (
            <Breadcrumbs breadcrumbs={breadcrumbs} color="light" />
          ) : undefined,
        }}
        heightClasses="h-48 lg:h-72"
        maskClasses="bg-black/0"
        imgAlign={bannerImagAlign}
      />

      <div className="brand-container mt-12 max-w-screen-md lg:mt-16 [&>p]:leading-[1.7]">
        {children}
      </div>

      <SEOMeta pageTitle={pageTitle} ogImage={ogImage} />
    </main>
  );
};

export default InfoPageLayout;
